import DigitalProductTitle from "%/dynamic-component-editor/standard-components/digital-product-card/DigitalProductTitle.vue";
import DigitalProductType from "%/dynamic-component-editor/standard-components/digital-product-card/DigitalProductType.vue";
import DigitalProductStartDate from "%/dynamic-component-editor/standard-components/digital-product-card/DigitalProductStartDate.vue";
import DigitalProductEndDate from "%/dynamic-component-editor/standard-components/digital-product-card/DigitalProductEndDate.vue";
import DigitalProductDescription from "%/dynamic-component-editor/standard-components/digital-product-card/DigitalProductDescription.vue";
import DigitalProductPrice from "%/dynamic-component-editor/standard-components/digital-product-card/DigitalProductPrice.vue";
import DigitalProductBuyButton from "%/dynamic-component-editor/standard-components/digital-product-card/DigitalProductBuyButton.vue";
import DigitalProductViewDetailsButton from "%/dynamic-component-editor/standard-components/digital-product-card/DigitalProductViewDetails.vue";
import DigitalProductDownloadButton from "%/dynamic-component-editor/standard-components/digital-product-card/DigitalProductDownloadButton.vue";
import DigitalProductsCommentsWidget from "%/dynamic-component-editor/standard-pages/digital-product-details-page/DigitalProductsCommentsWidget.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyDigitalProduct extends LegacyEntity {
  get elements() {
    return {
      DigitalProductTitle,
      DigitalProductType,
      DigitalProductPrice,
      DigitalProductStartDate,
      DigitalProductEndDate,
      DigitalProductDescription,
      DigitalProductBuyButton,
      // name diverges from file (DigitalProductViewDetails.vue).
      DigitalProductViewDetailsButton,
      DigitalProductDownloadButton,
      DigitalProductsCommentsWidget,
    };
  }
}
